import React, {FC} from "react";
import {useAxios} from "../../utils/hooks";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Button, Divider, message, Popconfirm, Tooltip} from "antd";
import {
    DeleteTwoTone,
    PlusOutlined,
    UploadOutlined
} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import ButtonWithIcon from "../../components/buttons/button-with-icon";
import LocationAssignmentRuleModel from "../../models/locationassignmentrules/location-assignment-rule-model";
import Drawer from "../../components/drawer/drawer";
import LocationAssignmentRuleDrawer from "../../forms/location-assignment-rule-form";
import {EditOutlined} from "@ant-design/icons";


const LocationAssignmentRulesScreen: FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [trigger, setTrigger] = useSafeState(false);
    const locationAssignmentRuleText = <Trans>Location Assignment Rule</Trans>

    const locationAssignmentRuleDrawer = Drawer(
        {
            title: locationAssignmentRuleText,
            children:
                <LocationAssignmentRuleDrawer/>,
            customClose: () => setTrigger(!trigger)
        }
    );

    const handleDelete = (record: any) => {
        if (axiosInstance.current != null) {
            axiosInstance.current
                .delete('/resource/location-assignment-rules/' + encodeURIComponent(record.id))
                .then(() => {
                    message.success('Successfully deleted.');
                    setTrigger(!trigger);
                })
                .catch(function (error: any) {
                    message.error('Error while deleting');
                });
        }
    };

    const action = (record: any) => {

        return (
            <>
                <Tooltip title={<Trans>Edit</Trans>}>
                    <EditOutlined className={"ActionButtons"} style={{color: "#40a9ff"}}
                                  onClick={() =>
                                      locationAssignmentRuleDrawer
                                          .open(
                                              "Edit",
                                              {
                                                  id: record.id,
                                                  location: record.location,
                                                  item: record.item,
                                                  quantity: record.quantity,
                                                  validFrom: record.validFrom,
                                                  validTo: record.validTo,
                                                  version: record.version
                                              })
                                  }
                    />
                </Tooltip>

                <Tooltip title={<Trans>Remove</Trans>}>
                    <Popconfirm
                        title={<Trans>Are you sure want to delete record?</Trans>}
                        onConfirm={() => handleDelete(record)}
                        okText={<Trans>Yes</Trans>}
                        cancelText={<Trans>No</Trans>}>
                        <DeleteTwoTone className={"ActionButtons"} twoToneColor={"red"}/>
                    </Popconfirm>

                </Tooltip>

            </>
        )
    };

    const actions = {
        width: 100,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const header = (
        <>
            <Button type={'primary'} onClick={() => locationAssignmentRuleDrawer.open('Add new')} style={{ float: 'left' }}>
                <ButtonWithIcon icon={<PlusOutlined />} text={<Trans>Add new</Trans>} />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
            {/*<Button disabled={true} onClick={() => alert('Upload File')} style={{ float: 'left' }}>*/}
            {/*    <ButtonWithIcon*/}
            {/*        icon={<UploadOutlined />}*/}
            {/*        text={<Trans>.csv upload</Trans>}*/}
            {/*    />*/}
            {/*</Button>*/}
            {/*<Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />*/}
        </>
    );


    return (<>

            <>

                <Breadcrumb style={{marginBottom: 10}}>
                    <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans id={'Location Assignment Rules'}></Trans></Breadcrumb.Item>
                </Breadcrumb>
                <DtoTable
                    tableHeader={header}
                    model={LocationAssignmentRuleModel}
                    action={actions}
                    trigger={trigger}
                    allowRefreshButton={true}
                    pageSize={100}
                    scroll={{x: 1300, y: "65vh"}}/>
            </>
            {locationAssignmentRuleDrawer.component}
        </>
    )
}
export default LocationAssignmentRulesScreen;
